<template>
  <b-modal
    ref="block-assistant-modal"
    no-close-on-backdrop
    hide-footer
    title="ระงับการใช้งานผู้ช่วย"
    ok-variant="success"
    ok-title="ระงับการใช้งานผู้ช่วย"
    cancel-title="ยกเลิก"
    footer-class="justify-content-between"
    @show="resetModal"
    @hidden="resetModal"
    class="position-relative"
  >
    <form
      ref="form"
      @submit.stop.prevent="handleSubmit"
    >

      <b-form-group
        label="ชื่อผู้ใช้"
      >
        <b-form-input
          v-model="input.username"
          type="text"
          disabled
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="หมายเหตุ"
      >
        <b-form-input
          v-model="input.blockNote"
          type="text"
        ></b-form-input>
      </b-form-group>

      <div class="d-flex justify-content-end mt-3 pt-3">
        <b-button variant="link" size="sm" class="text-secondary mr-3" @click="hideModal">ยกเลิก</b-button>
        <b-button type="submit" variant="danger" size="sm" :disabled="isProcess">{{isProcess ? 'กำลังบันทึก...' : 'ตกลง'}}</b-button>
      </div>
    </form>

    <loading
      :active="isProcess"
      :can-cancel="false"
      :is-full-page="false"
      background-color="#EBEDEF"
      :height="30"
      :width="30"
      color="#007bff"
    />
  </b-modal>
</template>
<script>
import ManageAccountService from "@/services/ManageAccountService"
import Swal from 'sweetalert2'
import cAlert from '@/helpers/alert'

export default {
  name: 'BlockAssistantModal',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: {
        _id: null,
        username: null,
        blockNote: null
      }
    }
  },
  data() {
    return {
      isProcess: false,
      needReload: false,
      input: JSON.parse(JSON.stringify(this.data))
    }
  },
  watch: {
    isShow() {
      if(this.isShow){
        this.showModal()
      }else{
        this.hideModal()
      }
    },
    data() {
      this.input = JSON.parse(JSON.stringify(this.data))
    }
  },
  methods: {
    resetModal() {
      this.isProcess = false
      this.needReload = false
      this.input = {
        _id: null,
        username: null,
        blockNote: null
      }
    },
    showModal() {
      this.$refs['block-assistant-modal'].show()
    },
    hideModal() {
      this.$refs['block-assistant-modal'].hide()
    },
    handleSubmit() {

      const self = this
      this.isProcess = true
      ManageAccountService.blockAssistant(this.input)
      .then((response)=>{
        console.log(response)
        if(response.success) {
          this.needReload = true
          this.hideModal()
          this.$notify({
            type: 'success',
            title: 'สำเร็จ!',
            text: 'ระงับการใช้งานเสร็จเรียบร้อย',
          })
        }else{
          throw new Error()
        }
      })
      .catch((e)=>{
        console.log(e)
        cAlert({
          ...e,
          title: 'ผิดพลาด!',
          text: e.emessage || 'ระงับการใช้งานไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      })
      .finally(()=>{
        this.isProcess = false
      })
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.$emit('close', this.needReload)
    })
  }
}
</script>
